import styled from 'styled-components';
import { COLOR, TYPOGRAPHY } from '../../../theme/constants';
import config from './../../../config';

export const FrPickerContainer = styled.div`
   border-top: 1px solid ${COLOR.GRAYMEDIUM};

   &:last-of-type {
      border-bottom: 1px solid ${COLOR.GRAYMEDIUM};
   }

   @media (min-width: 1024px) {
      border: none;
   }
`;

export const FrPickerChannel = styled.div`
   ${TYPOGRAPHY.BOLD}
   font-size: 16px;
   line-height: 1.4;
   padding: 14px 12px;
   color: ${COLOR.BLACK};
   cursor: pointer;

   svg {
      margin-right: 12px;
   }

   @media (min-width: 1024px) {
      width: 230px;
      padding: 14px 20px;

      svg {
         display: none;
      }
   }

   @media (min-width: 1024px) {
      &.active {
         background: ${COLOR.BLUE};
         color: ${COLOR.WHITE};
         position: relative;
         z-index: 900;

         &:after {
            content: ' ';
            position: absolute;
            width: 0;
            height: 0;
            border-top: 20px solid transparent;
            border-bottom: 20px solid transparent;
            border-left: 20px solid ${COLOR.BLUE};
            top: 5px;
            right: -13px;
         }
      }
   }
`;

export const FrPickerCollection = styled.div`
   z-index: 2;
   padding: 0 0 20px 0;
   display: none;

   &.active {
      display: block;
   }

   @media (min-width: 1024px) {
      &.active {
         display: inline-block;
         position: absolute;
         width: 79.4%;
         top: 87px;
         left: 269px;
         padding: 20px 40px;
         bottom: 0;
         border-left: 1px solid ${COLOR.GRAYMEDIUM};
         overflow-y: auto;
      }
   }
`;

export const FrPickerCollectionNumbers = styled.ul`
   list-style: none;
   margin: 5px 0 5px 30px;
   padding: 0;

   li {
      margin: 0;
      padding: 5px;

      a {
         font-size: 14px;
         line-height: 1.2;
         color: ${COLOR.DARKGREY} !important;
         text-decoration: none !important;
         cursor: pointer;

         &:hover {
            text-decoration: none;
            color: ${COLOR.DARKGREY};
         }

         &.active {
            ${TYPOGRAPHY.BOLD}
            color: ${COLOR.BLUE} !important;
         }
      }
   }

   > li {
      padding: 5px 0;
   }

   @media (min-width: 1024px) {
      margin: 5px 0;

      &.active {
         column-count: 2;
      }
   }
`;

export const FrPickerCollectionNumbersCompare = styled.ul`
   list-style: none;
   margin: 0;
   padding: 0;

   > li {
      margin: 0;
      padding: 15px 0px 20px;
      border-top: 1px solid ${COLOR.GRAYMEDIUM};

      ul {
         column-count: 2;
      }

      &:first-child {
         border-top: none;
      }

      > a {
         ${TYPOGRAPHY.BOLD}
         font-size: 15px;
         margin-left: 30px;
         color: ${COLOR.BLACK};
         text-decoration: none;

         &:hover {
            text-decoration: none;
            color: ${COLOR.BLACK};
         }
      }
   }

   @media (min-width: 1024px) {
      li {
         a {
            margin-left: 0px;
         }
      }
   }
`;
